var _path, _mask, _rect, _path2, _mask2, _rect2, _path3, _rect3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeLinkShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3602 15.3984C11.5944 15.7615 11.9692 16.1745 12.2893 16.5001C12.4943 16.7086 12.3486 17.0781 12.0563 17.0781H4.94651C4.65411 17.0781 4.50844 16.7086 4.71343 16.5001C5.03351 16.1745 5.40836 15.7615 5.64255 15.3984C6.11792 14.6615 6.27952 13.5068 6.27952 13.5068H10.7232C10.7232 13.5068 10.8848 14.6615 11.3602 15.3984Z",
    fill: "white",
    stroke: "#363A45"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5137_28583",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.44629,
    y: 3.17383,
    width: 14.1103,
    height: 11.2227,
    rx: 0.636856
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.44629,
    y: 3.17383,
    width: 14.1103,
    height: 11.2227,
    rx: 0.636856,
    fill: "white",
    stroke: "#363A45",
    mask: "url(#path-2-inside-1_5137_28583)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84431 12.8185C2.97644 12.6006 2.72021 11.6533 2.72021 10.8355C2.72021 7.87035 3.63216 8.11981 3.60185 6.54726C3.56053 4.43473 4.58543 4.24526 4.96289 4.33684C9.24435 5.41363 11.6523 4.65261 11.6523 4.65261C13.3054 4.28 9.99925 7.71562 11.6523 11.2207C12.567 13.1975 5.28248 13.1785 3.84431 12.8185Z",
    fill: "#00C65E"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_5137_28583",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.44629,
    y: 0.578125,
    width: 14.1103,
    height: 3.02122,
    rx: 0.636856
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.44629,
    y: 0.578125,
    width: 14.1103,
    height: 3.02122,
    rx: 0.636856,
    fill: "white",
    stroke: "#363A45",
    mask: "url(#path-4-inside-2_5137_28583)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63691 3.11356C1.67495 2.99479 1.78538 2.91421 1.91009 2.91421H15.0909C15.2156 2.91421 15.326 2.99479 15.3641 3.11356L16.4009 6.3506C16.4602 6.53571 16.3221 6.72496 16.1278 6.72496H0.873213C0.678835 6.72496 0.540735 6.53571 0.60003 6.3506L1.63691 3.11356Z",
    fill: "white",
    stroke: "#363A45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.13916,
    y: 2.66064,
    width: 0.722434,
    height: 4.16762,
    fill: "#363A45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9565 2.66064H12.679L13.4014 6.82826H12.679L11.9565 2.66064Z",
    fill: "#363A45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04297 2.66064H4.32053L3.5981 6.82826H4.32053L5.04297 2.66064Z",
    fill: "#363A45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLinkShop);
export default __webpack_public_path__ + "static/media/homeLinkShop.859eeb269eb0831e5b829c275d13c2ca.svg";
export { ForwardRef as ReactComponent };